export default function Container({
    children,
    transparent = false,
    outterPadding = "py-12",
    size = "max-w-7xl",
    innerPadding = "p-6",
    textColor = "text-gray-900",
    hasShadow = false
}) {
    return (
        <div className={outterPadding}>
            <div className={`${size} mx-auto`}>
                <div
                    className={`${
                        transparent ? "" : "bg-white overflow-hidden"
                    }  ${hasShadow ? "shadow-sm" : ""} sm:rounded-lg`}
                >
                    <div className={`${innerPadding} ${textColor}`}>
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
}
